import React from "react";
import Button from "ui/Button";
import Body from "ui/Text/Body";
import { download } from "utils/general";

interface Props {
  regulation: string;
  label: string;
  className?: string;
}

const RegulationSection: React.FC<Props> = ({ regulation, label }) => {
  const downloadRegulation = () =>
    download(`${process.env.REACT_APP_BASE_RELATIVE_ROUTES}/assets/${regulation}`);

  return (
    <>
      <Body variant="body4" color="secondary">
        {label}
      </Body>
      <Button
        variant="outlined"
        className="regulation-button ml-sm"
        onClick={downloadRegulation}
      >
        Descarregar
      </Button>
    </>
  );
};

export default RegulationSection;
